
































import {Component, Vue} from 'vue-property-decorator';
import {WebService} from '@/services/web.service';
import moment from 'moment';
import {IMenu, MenuStore} from '@/store/modules/menu.store';
import MenuEdit from '@/components/MenuEdit.vue';
// @ is an alias to /src

@Component({
	components: {
		'menu-edit': MenuEdit
	}
})
export default class ManageMenus extends Vue {
	menuName = '';

	showLoading = true;
	showMenuLoading = false;
	showMenuEdit = false;
	selectedMenuId = '';

	get menus() {
		// This is to prevent the live menu from popping in early and making the UI look odd
		if(this.showLoading) {
			return [];
		}
		return MenuStore.menus.sort((a, b) => {
			if(a.name === b.name) {
				return 0;
			}
			return a.name > b.name ? 1 : -1;
		});
	}

	async created() {
		await WebService.started;
		await WebService.getMenus();
		this.showLoading = false;
	}

	get validMenuName() {
		return this.menuName.trim() !== '' && this.menus.map((menu) => {
			return menu.name.toLowerCase();
		}).indexOf(this.menuName.trim().toLowerCase()) === -1;
	}

	async createMenu() {
		try {
			this.showMenuLoading = true;
			const menuId = await WebService.createMenu({
				name: this.menuName
			});
			this.showMenuLoading = false;
			this.selectedMenuId = menuId;
			this.showMenuEdit = true;
			this.menuName = '';
		} catch(e) {
			this.showMenuLoading = false;
			await this.$bvModal.msgBoxOk('There was a problem creating your menu', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}

	menuClicked(menu: IMenu) {
		console.log(menu);
		this.selectedMenuId = menu.menuId;
		this.showMenuEdit = true;
	}
}
